import {findIndex} from 'lodash';

export const findExamIndex = (exams, examId) => {
    return findIndex(exams, (exam) => {
        return exam.id === examId;
    });
};

export const findExamTypeIndex = (configTypes, type) => {
    return findIndex(configTypes, (configType) => {
        return configType.value === type;
    });
};

export const findApplicantExamIndex = (applicanrExams, applicantExamId) => {
    return findIndex(applicanrExams, (applicanrExam) => {
        return applicanrExam.id === applicantExamId;
    });
};

export const isExistApplicantExam = (applicantExams, contestPriorityExams) => {
    let isFind = false;
    contestPriorityExams.forEach((contestPriorityExam) => {
        contestPriorityExam.type_rows.forEach((contestPriorityExamType) => {
            const examSpecification = {exam_id: contestPriorityExam.exam_id, type: contestPriorityExamType.type};
            if (findIndex(applicantExams, examSpecification) !== -1) {
                isFind = true;
            }
        });
    });
    return isFind;
};

export const findRatingApplicantsLink = (links, competitionId) => {
    return findIndex(links, (link) => {
        return link.id === competitionId;
    });
};
